import React from "react";

import "./backgroundVideo.css";

const BackgroundVideo = () => {
  return (
    <div className="video-container">
      <video autoPlay loop muted playsInline className="background-video">
        <source src={require("../../assets/video/home_top.mp4")} type="video/mp4" />
      </video>
    </div>
  );
};

export default BackgroundVideo;
